var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnbit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.8%",
    y1: "84.9%",
    x2: "106.3%",
    y2: "-17.2%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0877FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCEF9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8599735,0.000607031223 C64.4416737,0.000607031223 63.0363726,0.0454744869 61.6440701,0.135209398 C59.3754119,0.301605871 57.6214113,2.19771449 57.6274798,4.47722124 L57.6274798,32.8001645 C57.6294466,34.0359685 58.1568063,35.2123819 59.0774227,36.0346405 C59.9980391,36.8568991 61.224677,37.2470878 62.4499879,37.1074402 C63.5818523,36.9749894 64.7204182,36.9083004 65.8599735,36.9077077 C77.6016631,36.9077077 88.1871903,43.995619 92.6805403,54.8663598 C97.1738904,65.7371006 94.690175,78.2498645 86.3875466,86.5699693 C78.0849183,94.8900741 65.5984376,97.3790175 54.7505309,92.8762093 C43.9026243,88.373401 36.8296011,77.765592 36.8296011,65.999187 L36.8296011,19.2231276 C36.8304083,16.5637094 35.3161377,14.1371901 32.9297089,12.9738059 C30.54328,11.8104217 27.7035052,12.1143438 25.6160782,13.7565347 C9.44722987,26.2414401 -0.0174670853,45.544213 2.42011117e-05,65.999187 C2.42011117e-05,102.411298 30.0832892,132.297366 66.4189165,131.997767 C102.792362,131.843094 132.153742,102.169136 131.999394,65.7191272 C131.845046,29.269118 102.233419,-0.154065705 65.8599735,0.000607031223 Z",
    id: "Shape-Copy",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnbit);
export default __webpack_public_path__ + "static/media/ownbit.7cdacfe7d7ff048eb7e31847c8b3f5e1.svg";
export { ForwardRef as ReactComponent };